import { BasicInput } from "@/view/components/BasicInput";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/view/components/ui/alert-dialog";
import { Button } from "@/view/components/ui/button";
import { Spinner } from "@/view/components/ui/spinner";
import { FormProvider } from "react-hook-form";
import { useEditCpfModalController } from "./useEditCpfModalController";
import { cpfMask } from "@/app/utils/cpfFormater";

interface EditCpfModalProps {
  open: boolean;
  onClose: () => void;
  sellerId: string;
}

export const EditCpfModal: React.FC<EditCpfModalProps> = ({
  open,
  onClose,
  sellerId,
}) => {
  const { form, errors, register, isSubmitting, handleSubmit, onSubmit } =
    useEditCpfModalController({ open, onClose, sellerId });

  return (
    <AlertDialog open={open}>
      <AlertDialogContent
        className="max-w-sm"
        onClick={(e) => e.stopPropagation()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Alterar CPF</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          <FormProvider {...form}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col gap-3"
            >
              <div className="mb-3">
                <p className="text-md font-medium">CPF</p>
                <BasicInput
                  className="text-xl"
                  placeholder="000.000.000-00"
                  error={errors.cpf?.message}
                  {...register("cpf")}
                  onInput={cpfMask}
                />
              </div>
              <AlertDialogFooter>
                <AlertDialogCancel type="button" onClick={onClose}>
                  Fechar
                </AlertDialogCancel>
                <AlertDialogAction asChild>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
                  >
                    {isSubmitting ? <Spinner size={"small"} /> : "Confirmar"}
                  </Button>
                </AlertDialogAction>
              </AlertDialogFooter>
            </form>
          </FormProvider>
        </AlertDialogDescription>
      </AlertDialogContent>
    </AlertDialog>
  );
};
